import React from 'react'
import './SearchSelectDropdown.scss'

const SearchSelectDropdown = ({
  value,
  setValue,
  label,
  options, // [ {value: 'option-value', text: 'some text'} ]
  icon = null,
  forceStacked = false,
  infoTooltip = null,
}) => {
  return (
    <label
      className={`SearchSelectDropdown ${forceStacked ? 'force-stacked' : ''}`}
    >
      {icon && <img src={icon} alt="" />}

      <div className="label-and-input-container">
        <div className="title">{label}</div>
        <select onChange={(e) => setValue(e.target.value)} value={value}>
          {options.map((option) => (
            <option value={option.value} key={option.value}>
              {option.text}
            </option>
          ))}
        </select>

        {!!infoTooltip && (
          <div className="info-tooltip-container">{infoTooltip}</div>
        )}
      </div>
    </label>
  )
}

export default SearchSelectDropdown
